/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'mail': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M2 6a2.5 2.5 0 012.5-2.5h11A2.5 2.5 0 0118 6v7.667a2.5 2.5 0 01-2.5 2.5h-11a2.5 2.5 0 01-2.5-2.5V6zm2.5-1.5A1.5 1.5 0 003 6v7.667a1.5 1.5 0 001.5 1.5h11a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5h-11z" _fill="#1F222C"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M2.084 5.39a.5.5 0 01.693-.139L10 10.066l7.223-4.815a.5.5 0 01.554.832l-7.5 5a.5.5 0 01-.554 0l-7.5-5a.5.5 0 01-.139-.693z" _fill="#1F222C"/>'
  }
})
